import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import {apiCRMv3} from "../../services/api";

import Swal from "sweetalert2";

const SmartListCampaignList = (props) => {
    const [campaings, setCampaings] = useState([]);
    const [campaingsToShow, setCampaingsToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(function () {
        loadList();
    }, []);

    async function loadList() {
        setLoaded(false);

        const response = await apiCRMv3.get("/smart-list-campaign/get-dash");
        setCampaings(response.data.data);
        setCampaingsToShow(response.data.data);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const campaingsList = campaings;

        if (searchText === "") {
            setCampaingsToShow(campaingsList);
            setLoaded(true);
            return;
        }

        let filteredCampaing= campaingsList.filter(
            (campaings) =>
                campaings.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) !== -1
        );

        setCampaingsToShow(filteredCampaing);
        setLoaded(true);
    }

    async function endCampaign(strategistId) {
        try {
            await apiCRMv3.put(`/smart-list-campaign/${strategistId}/disable`);
            
            setTimeout(() => {
                window.location.reload();
            }, 5000);

            await Swal.fire({
                type: "success",
                title: "Sucesso!",
                text: "Campanha encerrada com sucesso. A página será atualizada em 5 segundos.",
                confirmButtonText: "OK",
            });
        } catch (error) {
            Swal.fire({
                type: "error",
                title: "Erro!",
                text: "Não foi possível encerrar a campanha.",
                confirmButtonText: "OK",
            });
        }
    }

    return (
        <Layout
            menuActive="campanhas-funil-mensagens"
            pageTitle="Lista de Campanhas"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                Lista de Campanhas Funil Mensagem de Texto Ativas
                            </div>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-8">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "40%" }}>Nome</th>
                                                <th style={{ width: "40%" }}>Criação</th>
                                                <th style={{ width: "40%" }}>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {campaingsToShow.map(
                                                (campaing, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    campaing.name
                                                                }
                                                            </td>
                                                            <td>
                                                                { 
                                                                    campaing.createdAt && new Date(campaing.createdAt).toLocaleDateString('pt-BR') 
                                                                }

                                                            </td>
                                                            <td>
                                                                <button 
                                                                    className="btn btn-xs btn-danger"
                                                                    onClick={() => endCampaign(campaing.strategistId)}
                                                                >
                                                                    Encerrar Campanha
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(SmartListCampaignList);
